import script from "./AudioRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&setup=true&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=38f72a7c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f72a7c"]])

export default __exports__